import moment from "moment";

export default function () {
  return {
    owner: {
      hire: {
        sub_account_name: "Total Hire Pay to Owner",
        breakdown: [
          {
            item_name: "Just A Period Hire",
            period: [
              moment().clone().format("YYYY-MM-DD"),
              moment().clone().add(100, "days").format("YYYY-MM-DD"),
            ],
            value_DAILY_HIRE: "12000",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "period",
          },
          {
            item_name: "Just A Period Hire2",
            period: [
              moment().clone().format("YYYY-MM-DD"),
              moment().clone().add(100, "days").format("YYYY-MM-DD"),
            ],
            value_DAILY_HIRE: "12000",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "period",
          },
          {
            item_name: "BB",
            value_BB: "122",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "Add Com",
            value_PERCENTAGE: "3.75",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "percentage",
          },
          {
            item_name: "Brokerage",
            value_PERCENTAGE: "1.25",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "percentage",
          },
        ],
      },
      freight: {
        sub_account_name: "C/P Contract Number...",
        breakdown: [
          {
            item_name: "Soybean",
            value_TONS: "30000",
            value_FREIGHT: "50",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
          {
            item_name: "Corn",
            value_TONS: "35000",
            value_FREIGHT: "50",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
        ],
      },
      cable_entertai_visual: {
        sub_account_name: "Cable/Entertaining/Victualling",
        breakdown: [
          {
            item_name: "Cable/Entertaining/Victualling",
            value_PER_DAY: "50",
            value_DAYS: "30",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
        ],
      },
      bunker_remaining: {
        sub_account_name: "Bunker Remaining....",
        breakdown: [
          {
            item_name: "VLSFO",
            value_TONS: "500",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
          {
            item_name: "HSFO",
            value_TONS: "500",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
          {
            item_name: "LSMGO",
            value_TONS: "500",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "two",
          },
        ],
      },
      off_hire: {
        sub_account_name: "Off Hire",
        breakdown: [
          {
            item_name: "Just A OFF Hire",
            period: [
              moment().clone().format("YYYY-MM-DD"),
              moment().clone().add(100, "days").format("YYYY-MM-DD"),
            ],
            value_DAILY_HIRE: "18250",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "period",
          },
          {
            item_name: "Cable/Entertaining/Victualling",
            value_DAYS: "3",
            value_DAILY_RATE: "50",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "two",
          },
          {
            item_name: "Addcom@3.75",
            value_Addcomc_Brokerage: "2000",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
      off_hire_bunker: {
        sub_account_name: "Bunker Consumption During Offhire",
        breakdown: [
          {
            item_name: "VLSFO",
            value_TONS: "5",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
          {
            item_name: "HSFO",
            value_TONS: "6",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
        ],
      },
      misc: {
        sub_account_name: "MISC",
        breakdown: [
          {
            item_name: "ILOHC",
            value_ILHOC: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "Bunker on-hire survey charge",
            value_BUNKER_ON_HIRE_SURVEY_CHARGE: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "Holds inspection",
            value_HOLDS_INSPECTION: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "B & C off-hire survey charge ",
            value_B_C_OFF_HIRE_SURVEY_CHARGE: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "fumi disposal",
            value_FUMI_DISPOSAL: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "PANAMA OE",
            value_PANAMA_OE: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "UWC",
            value_UWC: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
    },
    charterer: {
      freight: {
        sub_account_name: "C/P Contract Number...",
        is_freight: "",
        breakdown: [
          {
            item_name: "Soybean",
            bl_date: moment().clone().format("YYYY/MM/DD"),
            value_TONS: "30000",
            value_FREIGHT: "50",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "two",
          },
          {
            item_name: "Corn",
            bl_date: moment().clone().format("YYYY/MM/DD"),
            value_TONS: "35000",
            value_FREIGHT: "50",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "two",
          },
        ],
      },
      cable_entertai_visual: {
        sub_account_name: "Cable/Entertaining/Victualling",
        breakdown: [
          {
            item_name: "Cable/Entertaining/Victualling",
            value_PER_DAY: "50",
            value_DAYS: "30",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "two",
          },
        ],
      },
      dem_des: {
        sub_account_name: "Despatch/Demurrage",
        breakdown: [
          {
            item_name: "Despatch",
            value_Despatch: "18250",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "Demurrage",
            value_Despatch: "18250",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "one",
          },
        ],
      },
      hire: {
        sub_account_name: "Total Hire Pay to Owner",
        breakdown: [
          {
            item_name: "Just A Period Hire",
            period: [
              moment().clone().format("YYYY-MM-DD"),
              moment().clone().add(100, "days").format("YYYY-MM-DD"),
            ],
            value_DAILY_HIRE: "18250",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "period",
          },
          {
            item_name: "Total Hire",
            value_DAYS: "100.25",
            value_DAILY_HIRE: "18250",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
          {
            item_name: "BB",
            value_BB: "122",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "Addcom@3.75",
            value_Addcomc_Brokerage: "2000",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "one",
          },
        ],
      },
      bunker_remaining: {
        sub_account_name: "Bunker Remaining....",
        breakdown: [
          {
            item_name: "VLSFO",
            value_TONS: "500",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
          {
            item_name: "HSFO",
            value_TONS: "500",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
          {
            item_name: "LSMGO",
            value_TONS: "500",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "two",
          },
        ],
      },
      off_hire: {
        sub_account_name: "Off Hire",
        breakdown: [
          {
            item_name: "Just A OFF Hire",
            period: [
              moment().clone().format("YYYY-MM-DD"),
              moment().clone().add(100, "days").format("YYYY-MM-DD"),
            ],
            value_DAILY_HIRE: "18250",
            is_settled: false,
            debit_credit: "debit",
            calc_type: "period",
          },
          {
            item_name: "Addcom@3.75",
            value_Addcomc_Brokerage: "2000",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
      off_hire_bunker: {
        sub_account_name: "Bunker Remaining....",
        breakdown: [
          {
            item_name: "VLSFO",
            value_TONS: "5",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
          {
            item_name: "HSFO",
            value_TONS: "6",
            value_PRICE: "400",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "two",
          },
        ],
      },
      misc: {
        sub_account_name: "MISC",
        breakdown: [
          {
            item_name: "ILOHC",
            value_ILHOC: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "Bunker on-hire survey charge",
            value_BUNKER_ON_HIRE_SURVEY_CHARGE: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "Holds inspection",
            value_HOLDS_INSPECTION: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "B & C off-hire survey charge ",
            value_B_C_OFF_HIRE_SURVEY_CHARGE: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "fumi disposal",
            value_FUMI_DISPOSAL: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "PANAMA OE",
            value_PANAMA_OE: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "UWC",
            value_UWC: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
    },
    administrative: {
      bunker_replenish: {
        sub_account_name: "Bunker Replenish",
        breakdown: [
          {
            item_name: "LIANYUNFANG",
            value_TONS: "0",
            value_UNIT_PRICE: "600",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "tow",
          },
        ],
      },
      port_disbursement: {
        sub_account_name: "Port Disbursement",
        breakdown: [
          {
            item_name: "NOLA",
            value: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "PANAMA SB",
            value: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "HUANGHUA",
            value: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "TANGSHAN",
            value: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "2ND CTDC",
            value: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
      weather_routing_service: {
        sub_account_name: "Weather Routing Service",
        breakdown: [
          {
            item_name: "Ballast",
            value: "900",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "Laden",
            value: "900",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
      insurance: {
        sub_account_name: "Insurance",
        breakdown: [
          {
            item_name: "P&I to Hull",
            value: "4500",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "FDD",
            value: "0",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
      misc: {
        sub_account_name: "MISC",
        breakdown: [
          {
            item_name: "Hold Cleaning",
            value: "5000",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
      bank_charge: {
        sub_account_name: "Bank Charge",
        breakdown: [
          {
            item_name: "For Payable",
            value: "200",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
          {
            item_name: "For Receivable",
            value: "200",
            is_settled: false,
            debit_credit: "credit",
            calc_type: "one",
          },
        ],
      },
    },
  };
}
